import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#19364D",
    },
    secondary: {
      main: "#74E8C7",
    },
    background: {
      // default: "#e5e7eb",
      paper: "#ffffff",
    },
    error: {
      main: "#D32F2F",
      light: "#fdecea",
      contrastText: "#fff",
    },
    warning: {
      main: "#F9A825",
      light: "#fff8e1",
      contrastText: "#000",
    },
    info: {
      main: "#0288D1",
      light: "#e3f2fd",
      contrastText: "#fff",
    },
    success: {
      main: "#388E3C",
      light: "#e8f5e9",
      contrastText: "#fff",
    },
    neutral: {
      main: "#CFFFF5",
      contrastText: "#19364D"
    }
  },
  props: {
    MuiTooltip: {
      arrow: true,
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "2rem",
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: "#19364D",
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          color: "#19364D",
          ".MuiAlert-icon &": {
            color: "inherit",
          },
          "&.MuiTableSortLabel-icon": {
            color: "#ffffff !important"
          },
          "&.MuiTableSortLabel-iconDirectionAsc, &.MuiTableSortLabel-iconDirectionDesc": {
            color: "#ffffff !important",
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          color: "#19364D",
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#19364D",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#19364D",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "#19364D",
          },
        },
        input: {
          color: "#19364D",
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          color: "#19364D",
          "&.Mui-focused": {
            color: "#19364D",
          },
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "#19364D",
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: "#19364D",
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: "#FFFFFF",
          fontWeight: 600,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          "&:nth-of-type(even)": {
            // backgroundColor: '#f9f9f9',
          },
          "&:hover": {
            // backgroundColor: '#e0f7f4',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          color: "#D32F2F",
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
        },
        columnHeaders: {
          backgroundColor: "#19364D",
          color: "#ffffff",
          borderColor: "#ffffff",
          mt: 4,
          mb: 3,
        },
      },
    },
    MuiInput: {
    styleOverrides: {
      root: {
        color: "#ffffff",
        "& .MuiInputBase-input": {
          color: "#ffffff",
          "&::placeholder": {
            color: "#ffffff",
          },
        },
      },
      underline: {
        "&:before": {
          borderBottomColor: "#ffffff",
        },
        "&:after": {
          borderBottomColor: "#ffffff",
        },
        "&:hover:not(.Mui-disabled):before": {
          borderBottomColor: "#ffffff",
        },
      },
    },
  },
  },
});

export default theme;
